
import { ConnectionRenderer } from "../abstract/ConnectionRenderer";
import { AbstractShape } from "../abstract/Shape";
import { Connection } from "../clases/Connection";
import { Values } from "../clases/Values";
import { IConnections } from "../interfaces/Connections";
import { DBItem } from "../interfaces/Record";
import { getShapeWithId, getShapeWithNodeId } from "./ContainerUtils";
import { calculateArrowPosition, calculateConnectionPosition } from "./PositionUtils";

export function getArrowValues(connection: Connection, mainItems: AbstractShape[]) {
    let from = getShapeWithId(connection.from, mainItems);
    let to = getShapeWithId(connection.to, mainItems);
    if(!from || !to ) return { filledFrom: null, filledTo:null, values: null };
    let filledFrom = from.findFilled(mainItems);
    let filledTo = to.findFilled(mainItems);
    if (!filledFrom || !filledTo) return { filledFrom: null, filledTo: null, values: null };
    let values = calculateArrowPosition(filledFrom!, filledTo!, mainItems);
    return { filledFrom, filledTo, values };
}

export function getCreateConnectionValues(connection: Connection, mouse: Values, mainItems: AbstractShape[]) {
    let from = getShapeWithId(connection.from, mainItems);
    if(!from) return { filledFrom: null, values: null };
    let filledFrom = from!.findFilled(mainItems);
    if (!filledFrom) return { filledFrom: null, values: null };
    let values = calculateConnectionPosition(filledFrom!, mouse, mainItems);
    return { filledFrom, values };
}

export function createConection(id: string, fromItem: AbstractShape, toItem: AbstractShape, relation: DBItem | undefined, mainItems: AbstractShape[], conn?: IConnections, type?: string) {
    let values = calculateArrowPosition(fromItem, toItem, mainItems);
    let connection = new Connection(
        id,
        fromItem.id,
        toItem.id,
        values.x1,
        values.y1,
        values.x2,
        values.y2,
        fromItem,
        toItem,
        (conn) ? conn.type : type!,
        (relation) ? relation.properties.title : undefined
    );
    connection.setRelation(relation);
    connection.setConnection(conn);
    return connection;
}

export function updateConnections(connectionList: Connection[], mainItems: AbstractShape[]){
    for (const connection of connectionList) {
        let { filledFrom, filledTo, values } = getArrowValues(connection, mainItems);
        if (!filledFrom || !filledTo || !values) {
            connection.show = false;
            continue;
        }
        connection.x1 = values.x1;
        connection.y1 = values.y1;
        connection.x2 = values.x2;
        connection.y2 = values.y2;
        connection.iFrom = filledFrom;
        connection.iTo = filledTo;
        connection.show = true;
    }
}

export function updateCreateConnection(connection: ConnectionRenderer, mouse: Values, mainItems: AbstractShape[]) {
    let { filledFrom, values } = getCreateConnectionValues(connection, mouse, mainItems);
    if (!filledFrom || !values) {
        connection.show = false;
        return;
    }
    connection.x1 = values.x1;
    connection.y1 = values.y1;
    connection.x2 = values.x2;
    connection.y2 = values.y2;
    connection.iFrom = filledFrom;
    connection.show = true;
}

export function createIConnections(list: Connection[], compare: Connection[]): IConnections[] {
    let connectionList: IConnections[] = [];
    for (const conn of list) {
        let iConn = conn.transformToIConnection();
        connectionList = [...connectionList, iConn];
    }
    return connectionList;
}

export function recreateConnection(connections: IConnections[], relations: DBItem[], connectionsList: Connection[], mainItems: AbstractShape[]){
    for (const conn of connections) {
        let from = getShapeWithId(conn.from, mainItems);
        let to = getShapeWithId(conn.to, mainItems);
        let relation = relations.find((rel)=>conn.relation===rel.properties.__EDT_UUID__);
        if(!from || !to) continue;
        if(relation) relation.isUsed = true;
        connectionsList.push(createConection(conn.relation, from!, to!, relation, mainItems, conn));
    }
}

export function makeConnections(relations: DBItem[], connectionList: Connection[], mainItems: AbstractShape[]) {
    for (const rel of relations) {
        let findRelation = connectionList.some((conn) => {
            if (!conn.relation) return false;
            return conn.relation.startNodeElementId === rel.startNodeElementId && conn.relation.endNodeElementId === rel.endNodeElementId && conn.relation.type === rel.type
        });
        if (findRelation) continue;
        let from = getShapeWithNodeId(rel.startNodeElementId, mainItems);
        let to = getShapeWithNodeId(rel.endNodeElementId, mainItems);
        if (!from || !to) continue;
        rel.isUsed = true;
        let connection = createConection(rel.properties.__EDT_UUID__, from!, to!, rel, mainItems, undefined, rel.type);
        connectionList.push(connection);
    }
}